import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import analytics from 'src/js/modules/analytics';
import config from 'src/js/modules/config';

const TagManagerContainer = ({ children = null }) => {
  const dataLayerName = useSelector(config.selectors.getGoogleTagManagerDataLayerName);
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    analytics.tagManager.setDataLayer(dataLayerName, pathname);
  }, [pathname, dataLayerName]);

  return children;
};

TagManagerContainer.propTypes = {
  children: PropTypes.node,
};

export default TagManagerContainer;
